// ── Communication channels contract (REQ-8, REQ-10) ─────────────────────────
// LIVE backend integration (swapped from the mock-first build). Backend PR #1137:
// GET|PATCH comms/channels + suomi.fi eligibility (REQ-10 strong-auth gate).
import { apiClient } from 'src/api/client';
import type { ChannelId } from './types';

export type ChannelPref = {
  id: ChannelId;
  enabled: boolean;
  /** The concrete address for the channel (email / phone); null for letter/suomifi. */
  address: string | null;
  /** REQ-10: suomi.fi is only offered to strongly-identified users. */
  available: boolean;
};

export type ChannelPrefs = {
  channels: ChannelPref[];
  /** When true, exactly one channel is the delivery channel (primaryChannel). */
  restrictToSingle: boolean;
  primaryChannel: ChannelId | null;
};

export type UpdateChannelPrefsInput = {
  channels: { id: ChannelId; enabled: boolean }[];
  primaryChannel: ChannelId | null;
};

export async function getChannelPrefs(): Promise<ChannelPrefs> {
  return (await apiClient.get<ChannelPrefs>('comms/channels')).data;
}

export async function updateChannelPrefs(
  input: UpdateChannelPrefsInput
): Promise<ChannelPrefs> {
  return (await apiClient.patch<ChannelPrefs>('comms/channels', input)).data;
}

// REQ-10: suomi.fi channel eligibility (strong-auth gate).
export async function getSuomiFiEligibility(): Promise<{ available: boolean }> {
  return (
    await apiClient.get<{ available: boolean }>('comms/suomifi/eligibility')
  ).data;
}
